
import {BaseModel} from '../../shared/entities/base.model';
import {UserModel} from '../../auth/models/user.model';


export class CandidateModel extends BaseModel {
    user: UserModel;
    candidation: CandidationModel;
}

export class CandidationModel extends BaseModel {
    jobUid: string;
    description: string;
    status: string;
    created_at: Date;
    updated_at: Date;

}
